import {
  ActionCard,
  Assessment,
  ConditionRule,
  ElementKind,
  Question,
  Section,
} from '@playbooks/core/src/interfaces/ActionCard'

import calculateScores from './calculateScores'
import checkFirstResponseIfNeeded from './checkFirstResponseIfNeeded'
import isAssessmentAutoCollapsing from './isAssessmentAutoCollapsing'
import { sectionTypes } from '@playbooks/core/src/constants'

/* This function adds some essential props to the ac json */
function enrichActionCardWithProps(ac: ActionCard) {
  /* !!! Increase the UPD_VERSION value of this function if its logic was changed. Prev value is 13. 25.03.2026 changed to 14 */
  const UPD_VERSION = 14

  if (ac._isEnriched && ac._updateVersion === UPD_VERSION) return false

  ac.conditionalItems ??= []
  ac.conditionalQuestions ??= []
  ac.enabledSeparators ??= []
  ac.lastActiveSeparator ??= -1
  ac.touchedSeparators ??= []
  ac.commentedHeaders ??= []
  ac._isEnriched = true
  ac._updateVersion = UPD_VERSION

  let sepId = -1

  ac.sections?.forEach(sec => {
    if (!ac.hasPinnedSections && sec.isPinned) {
      ac.hasPinnedSections = true
    }

    const isSeparator = sec.type === sectionTypes.SEPARATOR

    if (isSeparator) {
      sepId = sec.id
    }

    if (sepId && !isSeparator) {
      sec.idOfSep = sepId
    }

    if (!Object.hasOwn(sec, 'isSectionMinimized')) {
      sec.isSectionMinimized ??= !sec.isOpened
    }

    /* Adding separator id to the places where it needs */
    handleElements(sec, sepId)
  })

  calculateScores(ac)

  return true
}

function handleElements(sec: Section, sepId: number) {
  sec.elements?.forEach(element => {
    ;(element as Assessment).responses?.forEach(resp => {
      resp.idOfSep = sepId
    })
    ;(element as Question).idOfSep = sepId

    if (element.kind === ElementKind.ASSESSMENT) {
      handleAssessmentItem(sec, element as Assessment)
    }
  })
}

function handleAssessmentItem(sec: Section, item: Assessment) {
  const isAutoCollapse = isAssessmentAutoCollapsing(sec, item)

  item.isAutoCollapse ??= isAutoCollapse

  if (!isAutoCollapse) {
    item.checked = true

    if (item.tags?.length && !item.conditionRule) {
      item.conditionRule = ConditionRule.OR
    }
  }

  checkFirstResponseIfNeeded(item)
}

export default enrichActionCardWithProps
